import { axiosInstance } from ".";

/**
 * PROLINE-4025 — publishing and crew size change requests of every company.
 * `status`, `request_type` and `company_id` are comma-separated; the pagy headers carry the totals.
 */
const getPaymentRequests = (params) =>
  axiosInstance.get("/payment_requests", { params });

/** PROLINE-4030 — one request with its full event and crew size plan. */
const getPaymentRequest = (id, config) =>
  axiosInstance.get(`/payment_requests/${id}`, config);

/** PROLINE-4030 — records the payment and publishes the event. */
const acceptPaymentRequest = (id, config) =>
  axiosInstance.post(`/payment_requests/${id}/accept`, undefined, config);

/** PROLINE-4030 — returns the event to draft; the reason is emailed to the company. */
const rejectPaymentRequest = (id, rejectionReason, config) =>
  axiosInstance.post(
    `/payment_requests/${id}/reject`,
    { rejection_reason: rejectionReason },
    config,
  );

export {
  getPaymentRequests,
  getPaymentRequest,
  acceptPaymentRequest,
  rejectPaymentRequest,
};
